import { dom } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/pr-oad';
import store from '../store';

const { $id } = dom;
const { storeCommon } = store;
/**
 * 关闭骨架屏
 */
export const hideSkeleton = () => {
    const skeleton = $id('skeleton-screen');
    skeleton.style.opacity = 0;
    setTimeout(() => {
        skeleton.style.display = 'none';
    }, 500);
    // 骨架屏关闭上报
    oadLX.mv('b_waimai_x5e1ieiz_mv');
};
export const showSkeleton = () => {
    const skeleton = $id('skeleton-screen');
    skeleton.style.opacity = 1;
    skeleton.style.display = 'block';
};

// 全局loading
export const showLoading = (isShowLoading) => {
    storeCommon.isLoading = true;
    if (isShowLoading) {
        $id('loading').style.display = 'flex';
    }
};

export const hideLoading = () => {
    storeCommon.isLoading = false;
    $id('loading').style.display = 'none';
};
